// extracted by mini-css-extract-plugin
module.exports = {"tabs-wrapper":"TabbedView_tabs-wrapper__1PD11","tab-list":"TabbedView_tab-list__2WkkJ","tab":"TabbedView_tab__1ND-U","active":"TabbedView_active__11_-5"};